export default __webpack_public_path__ + "static/media/cf90b6b079424c491b9d5dca469d32fc.svg";